export enum ContractStatuses {
  ACTIVE = 1,
  INACTIVE = 0,
  DRAFT = 2,
}

export const CONTRACT_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
};

export const BASE_HASH = 'business-settings/pay-rates';

export enum CalculationTypeIds {
  SchedulePremium = '2QGnXdPmaKXpSOIOk1lnTcBql1n',
  RollingOvertime = '2ao2JOPQryNqV7hTpXoTQHRTerN',
  PeriodOvertime = '2QUX932Ur7RBvNUsPQwH2TkBnps',
  ConsecutiveDaysWorked = '2QWmCa6iRwK3cIvLNullQeYAH1y',
  MinShiftEngagement = '2ZnN8HKQwM8Dxavb653Xt1MM7AK',
  MinimumGapAfterOvertime = '2keiy7SQqJ2Xevg7VVlQuk9JHhN',
}

export const APP_PAY_EVENTS = {
  APP_PAY_RATES_OPEN: 'APP_PAY_RATES_OPEN',
  APP_PAY_RATES_CLOSE: 'APP_PAY_RATES_CLOSE',
};

export const ANALYTICS_EVENTS: EventObject = {
  VIEW_OPENED: {
    name: 'VIEW_OPENED',
    source: 'View pay rates',
    screen: 'BUSINESS_SETTINGS',
  },
  PAY_POLICY_ADD_STARTED: {
    name: 'PAY_POLICY_ADD_STARTED',
    source: 'Create Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_ADD_REQUESTED: {
    name: 'PAY_POLICY_ADD_REQUESTED',
    source_new: 'New Pay Rate',
    source_template: 'Template Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_ADD_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_ADD_SUCCESS_ACKNOWLEDGED',
    source_new: 'New Pay Rate',
    source_template: 'Template Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_ADD_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_ADD_FAILURE_ACKNOWLEDGED',
    source_new: 'New Pay Rate',
    source_template: 'Template Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_UPDATE_STARTED: {
    name: 'PAY_POLICY_UPDATE_STARTED',
    source: 'Update Pay Rate Details',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_UPDATE_REQUESTED: {
    name: 'PAY_POLICY_UPDATE_REQUESTED',
    source: 'Update Pay Rate Details',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_UPDATE_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_UPDATE_SUCCESS_ACKNOWLEDGED',
    source: 'Update Pay Rate Details',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_UPDATE_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_UPDATE_FAILURE_ACKNOWLEDGED',
    source: 'Update Pay Rate Details',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_DUPLICATE_STARTED: {
    name: 'PAY_POLICY_ADD_STARTED',
    source: 'Duplicate Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_DUPLICATE_REQUESTED: {
    name: 'PAY_POLICY_ADD_REQUESTED',
    source: 'Duplicate Pay Rate',
    source_edit_duplicate: 'Duplicate and Edit Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_DUPLICATE_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_ADD_SUCCESS_ACKNOWLEDGED',
    source: 'Duplicate Pay Rate',
    source_edit_duplicate: 'Duplicate and Edit Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_DUPLICATE_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_ADD_FAILURE_ACKNOWLEDGED',
    source: 'Duplicate Pay Rate',
    source_edit_duplicate: 'Duplicate and Edit Pay Rate',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_LEAVE_ENTITLEMENT_ADD_REQUESTED: {
    name: 'PAY_POLICY_LEAVE_ENTITLEMENT_ADD_REQUESTED',
    source: 'Add leave entitlements',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_LEAVE_ENTITLEMENT_ADD_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_LEAVE_ENTITLEMENT_ADD_SUCCESS_ACKNOWLEDGED',
    source: 'Add leave entitlements',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_LEAVE_ENTITLEMENT_ADD_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_LEAVE_ENTITLEMENT_ADD_FAILURE_ACKNOWLEDGED',
    source: 'Add leave entitlements',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_ADD_STARTED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_STARTED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_ADD_REQUESTED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_REQUESTED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_ADD_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_SUCCESS_ACKNOWLEDGED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_ADD_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_FAILURE_ACKNOWLEDGED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_DUPLICATE_STARTED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_STARTED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_DUPLICATE_REQUESTED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_REQUESTED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_DUPLICATE_SUCCESS_ACKNOWLEDGED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_SUCCESS_ACKNOWLEDGED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
  PAY_POLICY_PAY_RULE_DUPLICATE_FAILURE_ACKNOWLEDGED: {
    name: 'PAY_POLICY_PAY_RULE_ADD_FAILURE_ACKNOWLEDGED',
    source: 'Add Pay Rule',
    screen: 'PAY_RATE_BUILDER',
  },
};

export const AWARD_CODE = 'casual-2022-02-18-cpsa-2';

interface EventObject {
  [key: string]: {
    name: string;
    source?: string;
    source_new?: string;
    source_template?: string;
    source_edit_duplicate?: string;
    screen: string;
  };
}
